import {
  END_SLACK_FETCH,
  START_SLACK_FETCH,
  UPDATE_SLACK_INFO,
} from 'constants/actions';

export const updateSlackTeamInfo = teamInfo => {
  return {
    type: UPDATE_SLACK_INFO,
    team_info: teamInfo,
  };
};

export const endSlackFetch = () => {
  return { type: END_SLACK_FETCH };
};

export const startSlackFetch = () => {
  return { type: START_SLACK_FETCH };
};
